<template>
  <div>
    <v-dialog scrollable v-model="model" persistent max-width="1200px">
      <material-card
        v-if="model"
        :title="formTitle"
        :color="formColor"
        :icon="isNew ? 'add' : 'edit'"
      >
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="4" lg="4">
                  <pbas-date-picker
                    :label="$t('components.inmemorydependants.effective_date')"
                    :value="effectiveDate"
                    @update-date="effectiveDate = $event"
                    class="required"
                    :rules="[$rules.required, $rules.firstRenewalDate]"
                    :allowedDates="allowedDates"
                  ></pbas-date-picker>
                </v-col>
                <template v-if="effectiveDate && item">
                  <v-col cols="12" xs="12" sm="6" md="4" lg="4" v-if="isNew">
                    <auto-select
                      class="required"
                      :label="$t('headers.locals.union')"
                      :value.sync="item.Identity.Union"
                      :items="unions"
                      item-text="Name"
                      item-value="Id"
                      return-object
                      :rules="[$rules.required]"
                    ></auto-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" md="4" lg="4">
                    <trans-textbox
                      v-model="item"
                      :label="$t('globals.name')"
                      :rules="[$rules.required]"
                      field="Name"
                      class="required"
                    ></trans-textbox>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" md="4" lg="4">
                    <no-autocomplete-textfield
                      v-model="item.Number"
                      :label="$t('globals.number')"
                      :rules="[
                        $rules.alphanumeric,
                        $rules.dynamic.upToLength(5),
                        $rules.unionLocalNumberZeros,
                        rules.unique,
                        $rules.required,
                      ]"
                      class="required"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" md="4" lg="4">
                    <no-autocomplete-textfield
                      v-model="item.PhoneNumber"
                      :label="$t('globals.telephone')"
                      :rules="[rules.phone]"
                      v-mask="telephoneMask"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" md="4" lg="4">
                    <no-autocomplete-textfield
                      v-model="item.Fax"
                      :label="$t('globals.fax_number')"
                      :rules="[rules.phone]"
                      v-mask="telephoneMask"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="4">
                    <no-autocomplete-textfield
                      v-model="item.Email"
                      :label="$t('headers.contacts.email')"
                      :rules="[$rules.email]"
                    ></no-autocomplete-textfield>
                  </v-col>
                </template>
              </v-row>
            </v-form>
          </v-container>
          <template v-if="effectiveDate">
            <!-- <address-form
              ref="address"
              :provinces="options.Models.Province"
              :item="item"
              v-if="item"
              @valid="addressValid = $event"
            ></address-form> -->
            <span class="text-h6 ml-1">
              {{ $t("globals.address") }}
            </span>
            <canada-post-address
              :address="item.Address"
              @update-address="item.Address = $event"
              @valid="validAddress = $event"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="saving" text @click="$emit('close', false)">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="!valid || !validAddress"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TransTextbox from "@/components/TransTextbox.vue";
// import AddressForm from "@/components/AddressForm.vue";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";
import AutoSelect from "@/components/AutoSelect.vue";
import { translate2 } from "@/trans2";
import ErrorHandler from "@/components/ErrorHandler";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "@/components/CanadaPostAddress";

export default {
  components: {
    TransTextbox,
    NoAutocompleteTextfield,
    // AddressForm,
    ErrorHandler,
    AutoSelect,
    CanadaPostAddress,
  },
  props: ["identityId", "isNew", "model", "unions"],
  directives: { mask },
  mounted() {},
  data() {
    return {
      valid: false,
      effectiveDate: null,
      item: null,
      error: null,
      saving: false,
      defaultItem: {
        Translations: [],
        Identity: {},
      },
      snackbar: false,
      // addressValid: true,
      telephoneMask: "(###) ### - ####",
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
        unique: (v) => {
          console.log("unique validation", this.isNumberUnique);
          return (
            this.originalNumber === this.item.Number ||
            this.isNumberUnique ||
            this.$t("validation.unique_number")
          );
        },
      },
      isNumberUnique: true,
      uniqueNumberMonitor: null,
      originalNumber: null,
      validAddress: true
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planIdentity"]),
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    formTitle() {
      if (this.effectiveDate === null || this.effectiveDate == undefined) {
        return this.$t(
          "components.memberview.select_effective_date"
        );
      }
      if (this.isNew) {
        return this.$t("views.unionlocals.create_new_union_local");
      }
      return this.$t("views.unionlocals.edit_union_local_{0}", [
        translate2(this.item, "Name"),
      ]);
    },
  },
  watch: {
    model: {
      handler(v) {
        console.log("model: ", v);
        if (v) {
          this.effectiveDate = null;
        }
      },
      immediate: true,
    },
    effectiveDate: {
      async handler(v) {
        if (v) {
          if (this.isNew) {
            this.item = JSON.parse(JSON.stringify(this.defaultItem));
          } else {
            try {
              // this.item = await this.lock(
              //   this.getUnionLocalByEffectiveDate,
              //   {
              //     planIdentityId: this.selectedPlan.Id,
              //     identityId: this.identityId,
              //     effectiveDate: this.effectiveDate,
              //     // dialogs: this.dialogs,
              //     // dialog: "edit",
              //   },
              //   () => {
              //     // this.dialogs.edit = false;
              //   }
              // );
              this.item = (await this.getUnionLocalByEffectiveDate({
                planIdentityId: this.selectedPlan.Id,
                identityId: this.identityId,
                effectiveDate: this.effectiveDate,
              })).data;
              this.originalNumber = this.item.Number;
              if (!this.item.Address) this.item.Address = {};
            } catch (error) {
              this.error = error;
            }
          }
        }
      },
      immediate: true,
    },
    "item.Number": {
      async handler(v) {
        console.log("number is :", v, this.item, this.union);
        if (v === null || v === undefined) {
          return;
        }
        const obj = {};
        this.uniqueNumberMonitor = obj;
        await this.delay(800);
        if (this.uniqueNumberMonitor !== obj) {
          return;
        }
        // try {
        const payload = {
          UnionName: this.item.Identity.Union.Name,
          TradeCode: this.item.Identity.Union.TradeCode,
          Name: translate2(this.item, "Name"),
          Number: this.item.Number,
        };
        console.log(payload);
        this.isNumberUnique = (await this.checkUnionLocalNumberUnique({
          planIdentityId: this.planIdentityId,
          payload: payload,
        })).data;

        console.log("response is: ", this.isNumberUnique);
        this.$refs.form.validate();
        // } catch (error) {
        //   this.error = error;
        // }
      },
      immediate: true,
    },
    "item.Name": {
      async handler(v) {
        if (this.item.Number === null || this.item.Number === undefined) {
          return;
        }
        console.log("number is :", v, this.item, this.union);
        if (v === null) {
          return;
        }
        const obj = {};
        this.uniqueNumberMonitor = obj;
        await this.delay(800);
        if (this.uniqueNumberMonitor !== obj) {
          return;
        }
        // try {
        const payload = {
          UnionName: this.item.Identity.Union.Name,
          TradeCode: this.item.Identity.Union.TradeCode,
          Name: translate2(this.item, "Name"),
          Number: this.item.Number,
        };
        console.log(payload);
        this.isNumberUnique = (await this.checkUnionLocalNumberUnique({
          planIdentityId: this.planIdentityId,
          payload: payload,
        })).data;

        console.log("response is: ", this.isNumberUnique);
        this.$refs.form.validate();
        // } catch (error) {
        //   this.error = error;
        // }
      },
    },
    "item.Identity.Union": {
      async handler(v) {
        if (this.item.Number === null || this.item.Number === undefined) {
          return;
        }
        console.log("number is :", v, this.item, this.union);
        if (v === null) {
          return;
        }
        const obj = {};
        this.uniqueNumberMonitor = obj;
        await this.delay(800);
        if (this.uniqueNumberMonitor !== obj) {
          return;
        }
        // try {
        const payload = {
          UnionName: this.item.Identity.Union.Name,
          TradeCode: this.item.Identity.Union.TradeCode,
          Name: translate2(this.item, "Name"),
          Number: this.item.Number,
        };
        console.log(payload);
        this.isNumberUnique = (await this.checkUnionLocalNumberUnique({
          planIdentityId: this.planIdentityId,
          payload: payload,
        })).data;

        console.log("response is: ", this.isNumberUnique);
        this.$refs.form.validate();
        // } catch (error) {
        //   this.error = error;
        // }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", [
      "newUnionLocal",
      "updateUnionLocal",
      "getUnionLocalByEffectiveDate",
      "checkUnionLocalNumberUnique",
    ]),
    save() {
      console.log(JSON.stringify(this.item));
      let item = JSON.parse(JSON.stringify(this.item));
      item.Name = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      delete item["@odata.context"];
      if (item.Address) {
        if (item.Address.Province) {
          item.Address.ProvinceId = item.Address.Province.Id;
          delete item.Address.Province;
          item.Address.UnionLocalId = item.Id;
          if (item.Address.Country) {
            item.Address.CountryId = item.Address.Country.Id;
            delete item.Address.Country;
          }
        } else {
          delete item.Address;
        }
      }
      if (!item.Fax) delete item.Fax;
      if (!item.PhoneNumber) delete item.PhoneNumber;
      if (item.Identity.Union) {
        item.Identity.UnionId = item.Identity.Union.Id;
        delete item.Identity.Union;
      }
      item.EffectiveDate = this.effectiveDate;
      item.PhoneNumber = this.unmask(item.PhoneNumber, this.telephoneMask);
      item.Fax = this.unmask(item.Fax, this.telephoneMask);
      console.log(JSON.stringify(item));
      if (this.isNew) {
        this.add(item);
      } else {
        this.update(item);
      }
    },
    async update(item) {
      this.saving = true;
      item.IdentityId = this.identityId;
      if (item.Identity) {
        delete item.Identity;
      }
      try {
        await this.updateUnionLocal({
          planIdentityId: this.selectedPlan.Id,
          payload: item,
        });
        this.snackbar = true;
        this.$emit("close", true);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async add(item) {
      item.PlanIdentityId = this.selectedPlan.Id;
      this.saving = true;
      try {
        await this.newUnionLocal({
          planIdentityId: this.selectedPlan.Id,
          payload: item,
        });
        this.snackbar = true;
        this.$emit("close", true);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    // isValid() {
    //   if (!this.$refs.addressForm) {
    //     return false;
    //   }
    //   if (this.item.Address === null || this.item.Address === undefined) {
    //     return this.valid;
    //   }
    //   if (Object.keys(this.item.Address).length === 0) {
    //     return this.valid;
    //   }
    //   return this.valid && this.$refs.addressForm.valid;
    // }
    allowedDates(val) {
      console.log(this.planIdentity.FirstRenewalDate);
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style></style>
